export class CoreBase<TPkType> {
    id: TPkType;
}
